import React from 'react';
import { withFeatures } from '../features/withFeatures';
import { DoctrinePresentation } from '../presentation/DoctrinePresentation';
import { SignupBanner } from '../signup/SignupBanner';
import { PricingBanner } from '../pricing/PricingBanner';

export const RawHomePublic: React.FC = () => {
  return (
    <>
      <DoctrinePresentation />
      <PricingBanner />
      <SignupBanner />
    </>
  );
};

export const HomePublic = withFeatures('public-home/fr')(RawHomePublic);
